import Animated from 'assets/images/composition/animated-emoji.webp';
import Happy from 'assets/images/composition/happy-emoji.webp';
import Nervous from 'assets/images/composition/nervous-emoji.webp';
import Neutro from 'assets/images/composition/neutro-emoji.webp';
import Satisfied from 'assets/images/composition/satisfied-emoji.webp';
import Tired from 'assets/images/composition/tired-emoji.webp';

const EmotionList = {
  neutral: {
    label: 'Neutro',
    emoji: Neutro,
  },
  excited: {
    label: 'Animado',
    emoji: Animated,
  },
  nervous: {
    label: 'Nervoso',
    emoji: Nervous,
  },
  tired: {
    label: 'Cansado',
    emoji: Tired,
  },
  content: {
    label: 'Satisfeito',
    emoji: Satisfied,
  },
  happy: {
    label: 'Feliz',
    emoji: Happy,
  },
};

export default EmotionList;
